import React, { useMemo } from "react"
import CTA from "../UI/CTA"
import InfoWithImageSection from "../UI/InfoWithImageSection"
import IntroSection from "../UI/IntroSection"
import MediaQuery from "react-responsive"

const FinancingMobile: React.FC = () => {
    const isTablet = MediaQuery({ minWidth: 540 })
    const srcImg = useMemo(() => `https://gabcomercio.azureedge.net/azul-agro/${isTablet ? 'tablet' : 'mobile'}/financing/introSection.webp`, [isTablet])

    return (
        <main>
            <IntroSection title="Financiamento" text="" img={srcImg} justifyContent="flex-end" paddingRight={64} />
            <CTA href="/financiamento/contato" text="Quer saber mais sobre o financiamento? Solicite a visita de um consultor." flexDirection="column" />
            <InfoWithImageSection flexDirection={"column"} title={"Banco CNH"} text={"Banco CNH Industrial. O banco de quem PRODUZ, CONSTRÓI E TRANSPORTA. Banco de fábrica da New Holland e nosso maior suporte no processo de financiamento de equipamentos agrícolas. Com o intuito de atender todos os portes de produtores, traz as principais linhas de financiamento BNDES como Moderfrota*, Pronaf* e linhas especiais como CDC. É agilidade no crédito ao produtor."} img={"https://gabcomercio.azureedge.net/azul-agro/general/financing/img1.webp"} width={530} height={600} hasButton href="/financiamento/contato" />
        </main>
    )
}

export default React.memo(FinancingMobile)
